import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { trackSiteEntrance, trackEvent } from './utils/analytics'
import { injectCriticalIcons, loadFullIconLibrary } from './utils/iconLoader'
import { preloadCriticalFonts } from './utils/styleLoader'

require("./assets/css/main.scss");

// Inject critical icons first (these are used in the header/navigation)
injectCriticalIcons([
  'bars', 'times', 'phone', 'envelope', 'music',
  'facebook', 'instagram', 'youtube', 'whatsapp'
]);

// Check if we need to optimize font loading
document.addEventListener('DOMContentLoaded', () => {
  // Start font loading optimization
  try {
    // Only optimize font loading if not already loaded in this session
    if (!sessionStorage.getItem('fonts-loaded')) {
      preloadCriticalFonts(['Heebo'], [400, 700]); // Just load the most critical weights first
    } else {
      // Fonts already loaded in this session
      document.documentElement.classList.add('fonts-loaded');
    }
  } catch (e) {
    // Session storage not available, load fonts anyway
    preloadCriticalFonts();
  }
});

// Load full icon library asynchronously after page load
window.addEventListener('load', () => {
  // Use requestIdleCallback if available, otherwise setTimeout
  if (window.requestIdleCallback) {
    window.requestIdleCallback(() => {
      loadFullIconLibrary();
      
      // Load remaining font weights when idle
      preloadCriticalFonts();
    }, { timeout: 2000 });
  } else {
    setTimeout(() => {
      loadFullIconLibrary();
      
      // Load remaining font weights when idle
      preloadCriticalFonts();
    }, 2000);
  }
});

// Track initial site entrance
window.addEventListener('load', () => {
  // Make sure GA has loaded
  if (window.gtag) {
    // Wait a short time to ensure everything is loaded
    setTimeout(() => {
      trackSiteEntrance();
      // Log a console message for debugging
      console.log('🔍 Site entrance tracked');
    }, 1000);
  } else {
    console.warn('Google Analytics (gtag) not found');
  }
});

// Track page views on route changes
router.beforeEach((to, from, next) => {
  // Wait for the next tick to ensure the page has changed
  setTimeout(() => {
    /* eslint-disable */
    // GA4 tracking (preferred method)
    if (window.gtag) {
      gtag('config', 'UA-216504737-1', {
        page_path: to.path,
        page_title: to.name || document.title
      });
      
      // Also track as a custom event for better visibility
      trackEvent('page_view', {
        page_path: to.path,
        page_title: to.name || document.title
      });
      
      console.log('📊 Page view tracked:', to.path);
    } 
    // Legacy Universal Analytics tracking
    else if (window.ga) {
      ga('set', 'page', to.path);
      ga('send', 'pageview');
      console.log('📊 Legacy page view tracked:', to.path);
    }
    /* eslint-enable */
  }, 0);
  
  next(); // Make sure to call next()
});

createApp(App).use(store).use(router).mount('#app')

// Simple service worker registration
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', { 
      scope: '/'
    })
      .then(registration => {
        console.log('ServiceWorker registered with scope:', registration.scope);
      })
      .catch(error => {
        console.error('ServiceWorker registration failed:', error);
      });
  });
}